import React from "react";

import { useNavigate } from "react-router-dom";

import { useToast } from "hooks/toast";

import { ForgotPassword as ForgotPasswordTemplate } from "features/auth/ForgotPassword";
import { LeftTemplate } from "features/auth/LeftTemplate";

import { LanguageSelector } from "components/LanguageSelector";

export const ForgotPassword: React.FC = () => {
  const { addToast } = useToast();
  const navigate = useNavigate();

  return (
    <div
      style={{ display: "flex", flexDirection: "row", position: "relative" }}
    >
      <div style={{ position: "absolute", top: 16, right: 16, zIndex: 10 }}>
        <LanguageSelector />
      </div>
      <LeftTemplate backgroundImage="default" />
      <ForgotPasswordTemplate
        navigate={navigate}
        navigateTo="/"
        addToast={addToast}
      />
    </div>
  );
};
